var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 643 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.35;mix-blend-mode:multiply;}.cls-3{fill:#ff3f0b;}.cls-4{fill:#c1272d;opacity:0.66;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HPI_Nay_Text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Both"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remove"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 643,
    height: 107,
    xlinkHref: "HPI_Nay_Text1.png"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M636.17,18.08V84.6a13.68,13.68,0,0,1-13.7,13.68H19.8A13.68,13.68,0,0,1,6.1,84.6V18.08A13.68,13.68,0,0,1,19.8,4.38H622.47A13.69,13.69,0,0,1,636.17,18.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M600.7,33.68c-1.28-11.95-6.76-19.24-6.76-19.24l-7.41-9.87H549.35l-112.55,12,1.22-12h-9.11l-.08.36-2.06,4.53-11,24s-3.83,8.25-2.54,20.22l4.72,44.49h66.83l83.54-8.91.94,8.91H592l15.39-1.65ZM435.46,77.29a5.23,5.23,0,1,1,4.64-5.75A5.24,5.24,0,0,1,435.46,77.29Zm6-17.48a12.69,12.69,0,1,1,11.26-14A12.71,12.71,0,0,1,441.42,59.81ZM544.89,59l-71.81,7.66s-4.75-9.81,2.64-16.31l63.16-6.73C547.47,48.42,544.89,59,544.89,59Zm15.55-24.67a12.69,12.69,0,1,1,14,11.27A12.68,12.68,0,0,1,560.44,34.34Zm23.47,27.11a5.22,5.22,0,1,1,4.64-5.75A5.22,5.22,0,0,1,583.91,61.45Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpi);
export default __webpack_public_path__ + "static/media/hpi.103dbb40dce2c8c0711f3dbdf96dbaeb.svg";
export { ForwardRef as ReactComponent };